module.exports = __webpack_public_path__ + "media/bacteria-buzzing.b76e1a8e.mp3";